import React, { useImperativeHandle, forwardRef, useRef } from 'react';
import { useRefresh } from 'react-admin';

import { DialogoConfirmacao } from '../../../Components';
import { api } from '../../../services';

const FormDialog = forwardRef((props, ref) => {
  const refresh = useRefresh();
  const refDialogoConfirmacao = useRef(null);

  useImperativeHandle(ref, () => ({
    handleOpen(record) {
      if (refDialogoConfirmacao.current) {
        refDialogoConfirmacao.current.handleOpen(
          !record.is_search ? 'Incluir na pesquisa' : 'Excluir da pesquisa',
          !record.is_search
            ? 'Incluir na pesquisa do fc'
            : 'Excluir na pesquisa do fc',
          record,
        );
      }
    },
  }));

  async function handleConfirma(record) {
    await api.put(`/${'produtos-change-search'}/${record.id}`);
    refresh();
  }

  return (
    <DialogoConfirmacao
      ref={refDialogoConfirmacao}
      handleConfirma={handleConfirma}
    />
  );
});

export default FormDialog;
